<template>
    <div v-if="!loader" class="DetalhaFechamento">
        <h3 style="margin-top:0px">Duração, Atendimentos, Valores e Datas</h3>
        <div class="row grid-12 justify-space">
            <div class="grid-1 column">
                <label>Duração</label>
                {{ job.duracao_atendimento }}
            </div>
            <div class="grid-2 column">
                <label>Atendimentos</label>
                {{ job.dias_uteis_alocacao }}
            </div>
            <div class="grid-2 column">
                <label>Valor Job</label>
                {{ job.valor_job | money }}
            </div>
            <div class="grid-2 column">
                <label>Hora Extra </label>
                {{ job.valor_hora_extra | money }}
            </div>
            <div class="grid-2 column">
                <label>Ciclo</label>
                {{ form.dt_ciclo | date }}
            </div>
            <div class="grid-2 column">
                <label>Previsão Pag. </label>
                {{ form.dt_previsao_pagamento | date }}
            </div>
            <div class="grid-2 column">
                <label>Data Pag </label>
                {{ form.dt_pagamento ? (form.dt_pagamento | date) : 'Pendente' }}
            </div>
        </div>
        <h3>Custos dos Atendimentos</h3>
        <div class="row head">
            <div class="grid-3">Supporter</div>
            <div class="grid-2">Duração Atend.</div>
            <div class="grid-1">Valor Job</div>
            <div class="grid-2">H. extra</div>
            <div class="grid-2">Reembolso Desp.</div>
            <div class="grid-2">Valor Total</div>
        </div>
        <div class="container column">
            <div v-for="a of form.atendimentos" :key="a.id" class="row align-center">
                <div class="grid-3">{{ a.id_doutor }} {{ a.nome_doutor }}</div>
                <div class="grid-2">{{ a.duracao_atendimento }}</div>
                <div class="grid-1">{{ a.valor_atendimento | money }}</div>
                <div class="grid-2">{{ a.valor_horas_extras | money }}</div>
                <div class="grid-2">{{ a.valor_reembolso | money }}</div>
                <div class="grid-2">{{ a.total_atendimento | money }}</div>
            </div>
        </div>
        <h3>Custos do Job</h3>
        <div class="row grid-12 justify-space">
            <div class="grid-2 column">
                <label>Atendimentos</label>
                {{ form.atendimentos.length }}
            </div>
            <div class="grid-2 column">
                <label>Total Atendimentos</label>
                {{ form.total_atendimento | money }}
            </div>
            <div class="grid-2 column">
                <label>Total Horas Extras</label>
                {{ form.total_horas_extras }}
            </div>
            <div class="grid-2 column">
                <label>Total Reembolso</label>
                {{ form.total_reembolso | money }}
            </div>
            <div class="grid-2 column">
                <label>Total Job</label>
                {{ form.total_job | money }}
            </div>
        </div>
    </div>
    <div v-else class="row justify-center">
        <Loader />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader";

export default {
    name: "DetalhaFechamento",
    props: { job: Object },
    components: { Loader },
    data() {
        return {
            loader: true,
            form: {},
        }
    },
    methods: {
        ...mapActions("job", ["DETALHA_FECHAMENTO"]),
        async load() {
            this.loader = true
            await this.DETALHA_FECHAMENTO(this.job.id).then(({ data }) => this.form = data || {})
            this.loader = false
        },
    },
    mounted() {
        this.load()
    }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.DetalhaFechamento
    padding: 10px 30px
    padding-bottom: 40px
    overflow: auto
    min-width: 800px
    label
        @include label
    h3
        color: $blue-1
        margin-top: 40px
        margin-bottom: 10px
    .head
        color: $purple
        font-size: 14px
        margin-bottom: 10px
    .container
        font-size: 15px
        .row
            padding: 10px 5px
            border-radius: 4px
            &:nth-child(odd)
                background: #eee
</style>